import axios from "axios";
import { toast } from "react-toastify";
import authHeader from "./auth-header";

export const fetchAllAreas = (filters = {}) => {
  return new Promise((resolve, reject) => {
    const query_string = new URLSearchParams(filters).toString();
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/area?${query_string}`, {
        headers: authHeader(),
      })
      .then((res) => {
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const fetchOneArea = (id) => {
  return new Promise((resolve, reject) => {
    if (!id) return resolve(null);
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/area/${id}`, {
        headers: authHeader(),
      })
      .then((res) => {
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const createArea = (data) => {
  return new Promise((resolve, reject) => {
    if (!data) return resolve(null);
    axios
      .post(`${process.env.REACT_APP_BASE_URL}/area/`, data, {
        headers: authHeader(),
      })
      .then((res) => {
        toast.success(res.data.msg);
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const updateArea = (data, id) => {
  return new Promise((resolve, reject) => {
    if (!id || !data) return resolve(null);
    axios
      .put(`${process.env.REACT_APP_BASE_URL}/area/${id}`, data, {
        headers: authHeader(),
      })
      .then((res) => {
        toast.success(res.data.msg);
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const deleteArea = (id) => {
  return new Promise((resolve, reject) => {
    if (!id) return resolve(null);
    axios
      .delete(`${process.env.REACT_APP_BASE_URL}/area/${id}`, {
        headers: authHeader(),
      })
      .then((res) => {
        toast.success(res.data.msg);
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};
